<template>
    <div class="famous-pedia-rwp-topbar">
        <div class="web-inner-content dsp-flex">
            <div class="famous-pedia-rwp-left dsp-flex">
                <h1 class="famous-pedia-rwp-h1">名人百科</h1>
                <div class="famous-pedia-rwp-left-menu">
                    <button class="famous-pedia-rwp-left-item" @click="clickHome">首页</button>
                    <button class="famous-pedia-rwp-left-item" @click="clickCollate">起盘</button>
                    <button class="famous-pedia-rwp-left-item" @click="clickRecord">八字库</button>
                </div>
            </div>
            <div class="famous-pedia-rwp-search">
                <web-search-input></web-search-input>
            </div>
            <div v-if="userData && userData.token" class="famous-pedia-rwp-right">
                <span v-if="userData.info" class="famous-pedia-rwp-right-item" @click="clickAvatar">
                    <img class="web-top-bar-avatar-img" v-bind:src="userData.info.avatar" alt="">
                </span>
                <span @click="clickInform" class="famous-pedia-rwp-right-item"><i class="iconfont icon-my"></i></span>
                <span @click="clickMy" class="famous-pedia-rwp-right-item"><i class="iconfont icon-bell2"></i></span>
                <span @click="clickCollect" class="famous-pedia-rwp-right-item"><i class="iconfont icon-star2"></i></span>
            </div>
        </div>
    </div>
</template>

<script>
import WebSearchInput from '../../components/web/WebSearchInput.vue'
import { DOM } from '../../modules/dom';
export default {
    name: 'WebFamousPediaTopBar',
    components: { WebSearchInput },
    computed: {
        userData() {
            return this.$store.state.userData;
        }
    },
    methods: {
        clickCreate() {
            var me = this;
            this.$store.dispatch('weblogin/checkWebLogin', {
                sucCb: function() {
                    me.$store.dispatch('collate/resetData');
                    me.$store.dispatch('collate/initSizhuCollate');
                    me.$router.replace('/famouspediacreate');
                }
            });
        },
        clickHome() {
            this.$router.replace('/webhome');
        },
        clickCollate() {
            var me = this;
            this.$store.dispatch('weblogin/checkWebLogin', {
                sucCb: function() {
                    DOM.showPageByClassName('collate-page');
                    me.$router.replace('/collate');
                }
            });
        },
        clickRecord() {
            var me = this;
            this.$store.dispatch('weblogin/checkWebLogin', {
                sucCb: function() {
                    me.$router.replace('/record');
                }
            });
        },
        showMenu(menuId) {
            this.$store.state.weblogin.showWebFamousPediaPop = true;
            this.$store.state.weblogin.curWebFamousPediaNew = true;
            this.$store.state.weblogin.curWebFamousPediaMenu = menuId;
            // var me = this;
            // setTimeout(() => {
            //     me.$store.state.weblogin.showWebFamousPediaPop = false;
            // }, 5000);
        },
        clickAvatar() {
            this.showMenu(5);
        },
        clickCollect() {
            this.showMenu(1);
            this.$store.dispatch('famouspedia/initCurPediaList', {
                curId: 3,
                cb: function() {
                    setTimeout(() => {
                        var listDom = document.getElementById('FamousVirtualList');
                        if(listDom) {
                            listDom.style.height = '480px';
                        }
                    }, 100);
                }
            });
        },
        clickMy() {
            this.showMenu(2);
            this.$store.dispatch('famouspedia/initCurPediaList', {
                curId: 4,
                cb: function() {
                    setTimeout(() => {
                        var listDom = document.getElementById('FamousVirtualList');
                        if(listDom) {
                            listDom.style.height = '480px';
                        }
                    }, 100);
                }
            });
        },
        clickInform() {
            this.showMenu(3);
            this.$store.dispatch('inform/getMsgList', {
                cb: function() {
                    setTimeout(() => {
                        var listDom = document.getElementById('FamousInformList');
                        if(listDom) {
                            listDom.style.height = '480px';
                        }
                    }, 100);
                }
            });
        }
    }
}
</script>